import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { M010C025IconLinkExternalComponent } from '../../010-buttons-and-links/m010-c025-icon-link-external/m010-c025-icon-link-external.component';

@Component({
    selector: 'ui-m060-c030-vehicle-teaser',
    standalone: true,
    templateUrl: './m060-c030-vehicle-teaser.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLinkDirective,
        M000C010ImageComponent,
        M010C025IconLinkExternalComponent,
        FootnotesPipe,
        TrackingDirective,
    ],
})
export class M060C030VehicleTeaserComponent {
    image = input.required<{
        url: string;
        alt?: string | null;
    }>();
    imageCaption = input<string | null>();
    text = input.required<string>();
    link = input.required<string>();
    linkText = input.required<string>();
    externalLink = input<string>();
    externalLinkText = input<string | null>();
    shortInfos = input<Array<{ value: string; unit: string; label: string }>>();
    envkv = input<string>();
    isFirstView = input.required({ transform: booleanAttribute });
    disableEnvkv = input(false, { transform: booleanAttribute });
}
